import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { css } from 'glamor';
import { Modal, Grid, Row, Col, Pager } from 'react-bootstrap';
import { I18n } from 'react-redux-i18n';
import FormulaReviewSteps from './FormulaReviewSteps';
import LegislationComplianceReview from './LegislationComplianceReview';
import RawMatInformationReview from './RawMatInformationReview';
import CompoComment from './CompoComment';
import ProductDataReview from './ProductDataReview';
import ProductDataReview2 from './ProductDataReview2';
import FormulaReviewConclusion from './FormulaReviewConclusion';
import BaseLoader from '../../_Common/BaseLoader';

const style = {
  pager: {
    marginTop: '0px',
    marginBottom: '0px',
    marginRight: '17px',
    marginLeft: '17px',
  },
  modalBody: css({
    height: '70vh',
    overflowY: 'auto',
  }),
};

class FormulaReviewWizardModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 0,
    };
  }

  createAdd = numberToAdd => number => number + numberToAdd;
  addOne = this.createAdd(1);
  removeOne = this.createAdd(-1);

  handlePageChange = functor => {
    this.setState(({ activePage }) => ({
      activePage: functor(activePage),
    }));
  };
  isLastPage = () => this.state.activePage === 2;
  isFirstPage = () => this.state.activePage === 0;
  handlePreviousPage = () => this.handlePageChange(this.removeOne);

  handleNextPage = () => {
    if (this.isLastPage()) {
      this.props.saveFormulaReview();
    } else {
      this.handlePageChange(this.addOne);
    }
  };

  render() {
    const { title, closeModal, isLoading, ...otherProps } = this.props;
    const { activePage } = this.state;

    return (
      <div>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <div className={style.modalBody}>
          <Modal.Body>
            <BaseLoader isLoading={isLoading}>
              <Grid fluid>
                <Row>
                  <Col sm={12}>
                    <FormulaReviewSteps activeStep={activePage} />
                  </Col>
                </Row>
                <Row style={{ marginTop: '25px' }}>
                  {activePage === 0 && <LegislationComplianceReview {...otherProps} />}                 
                  {activePage === 1 && <CompoComment {...otherProps} />}
                  {activePage === 2 && <FormulaReviewConclusion {...otherProps} />}
                </Row>
              </Grid>
            </BaseLoader>
          </Modal.Body>
        </div>
        <Modal.Footer>
          <Pager style={style.pager}>
            {!this.isFirstPage() && (
              <Pager.Item previous disabled={isLoading} onClick={this.handlePreviousPage}>
                {`← ${I18n.t('general.previous')}`}
              </Pager.Item>
            )}
            <Pager.Item
              next
              disabled={isLoading}
              onClick={this.handleNextPage}
            >
              {this.isLastPage() ? I18n.t('general.save') : `${I18n.t('general.next')} →`}
            </Pager.Item>
          </Pager>
        </Modal.Footer>
      </div>
    );
  }
}

FormulaReviewWizardModal.propTypes = {
  title: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  saveFormulaReview: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formulaReview: PropTypes.shape({
    CompositionComment: PropTypes.string,
  }).isRequired,
};

export default FormulaReviewWizardModal;
